var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navBar',{attrs:{"title":"Ares - Users","home":true,"type":"gebr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }